(function() {
	'use strict';
	angular.module('app.leanProjects', ['ui.sortable', 'gantt', 'gantt.movable', 'gantt.tooltips', 'gantt.table', 'gantt.progress', 'gantt.resizeSensor']);
})();
